export const formatArcaDateFromTimestampToYYYYMMDD = (timestamp: string): string => {
	if (!timestamp) return '';

	try {
		return new Date(timestamp).toISOString().split('T')[0];
	} catch (error) {
		console.error('Error formatting date:', error);
		return '';
	}
};
